import React from "react";
import styled from "styled-components";

import Controls from "./controls";
import Video from "./video";
import { Box, Col, Row, Text } from "../../comps";
import MaterialIconButton from "@material-ui/core/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NAVBAR } from "../../theme/dimensions";
import { Theme } from "../../theme/theme-provider";

import {
  faCog,
  faVolumeUp,
  faClosedCaptioning,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";

const PLAYER_WIDTH = `( 55 * ( 100vw - ${NAVBAR.SIDE_WIDTH}px )) / 100`;
const PLAYER_HEIGHT = `9 * (${PLAYER_WIDTH}) / 16`;

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  align-items: center;
`;

const Head = styled(Row)`
  width: 90%;
  margin-top: 20px;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const VideoWrapper = styled(Box)`
  width: calc(${PLAYER_WIDTH});
  height: calc(${PLAYER_HEIGHT});
  border: 1px solid ${({ theme }) => theme.color.GRAY_1};
`;

const TextContainer = styled(Row)`
  margin-top: 2%;
  margin-bottom: 2%;
  padding: 8px;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
  background: ${({ theme }) => theme.color.BLACK_1};
  border-radius: 3px;
`;

const ControlsWrapper = styled(Box)`
  width: 100%;
`;

export default () => {
  const text1 = "Manually change the video resolution";
  const text2 = "Enable Captions";
  const text3 = "Change Volume";
  return (
    <Wrapper>
      <Head>
        <MaterialIconButton style={{ marginLeft: "10px" }} size="large">
          <FontAwesomeIcon
            style={{ fontSize: "24px", color: Theme.color.GRAY_1 }}
            icon={faCog}
          />
        </MaterialIconButton>
        <Text
          fontSize="24px"
          fontWeight={600}
          marginLeft="10px"
          color={Theme.color.GRAY_1}
        >{`Configure Player`}</Text>
      </Head>
      <Row
        style={{
          width: "100%",
          justifyContent: "space-around",
          marginTop: "30px",
        }}
      >
        {/*  its width should be <= (100 - player_width_percentage) */}
        <Col style={{ width: "25%" }}>
          <TextContainer>
            <FontAwesomeIcon
              style={{
                fontSize: "20px",
                color: Theme.color.GRAY_1,
                margin: "5px",
              }}
              icon={faVideo}
            />
            <Text
              color={Theme.color.GRAY_0}
              fontSize="18px"
              textAlign="left"
              marginLeft="8px"
            >
              {text1}
            </Text>
          </TextContainer>
          <TextContainer>
            <FontAwesomeIcon
              style={{
                fontSize: "20px",
                color: Theme.color.GRAY_1,
                margin: "5px",
              }}
              icon={faClosedCaptioning}
            />
            <Text
              color={Theme.color.GRAY_0}
              fontSize="18px"
              textAlign="left"
              marginLeft="8px"
            >
              {text2}
            </Text>
          </TextContainer>
          <TextContainer>
            <FontAwesomeIcon
              style={{
                fontSize: "20px",
                color: Theme.color.GRAY_1,
                margin: "5px",
              }}
              icon={faVolumeUp}
            />
            <Text
              color={Theme.color.GRAY_0}
              fontSize="18px"
              textAlign="left"
              marginLeft="8px"
            >
              {text3}
            </Text>
          </TextContainer>
          <ControlsWrapper>
            <Controls />
          </ControlsWrapper>
        </Col>
        <VideoWrapper>
          <Video />
        </VideoWrapper>
      </Row>
    </Wrapper>
  );
};
